// モジュールをインポート
import { fadeAnime } from "./modules/fadeAnime.js";

// 関数を実行
fadeAnime();
